import React from 'react';
import clsx from 'clsx';

import styles from './Info.module.scss';
import Icon from './Icon';
import Label from './Label';
import { BRAND_STYLE } from '../api/portletConfiguration';
import { BRAND_STYLES } from '../utils/Constants';

export default function Info({
	variant,
	focus,
	name,
	linkText,
	calcRoute,
	streetView,
	address,
	phone,
	fax,
	email,
	site,
	facebook,
	flex,
	routeDistance,
	routeTime,
	resultId,
	onCalcRouteClick,
	onStreetViewClick,
	icons,
	isRankedAgency
}) {
	if (flex === undefined) {
		flex = true;
	}

	const nameHTML = name ? <Label text={name} focus={focus} /> : null;

	const linkTextHTML = linkText && (isRankedAgency??false) ? (
		<a className={styles.link} href="#">
			{linkText} 
			<i className="icon icon-arrow-right"/>
		</a>
	) : null;

	const addressHTML = address ? (
		<Label text={address} variant="small" noUppercase={true} />
	) : null;

	const calcRouteHTML = calcRoute ? (
		<span id={`calcRoute_${resultId}`}>
			<Label
				text="Calcola percorso"
				onClick={onCalcRouteClick ? onCalcRouteClick : null}
				icon={
					<Icon
						textOn="right"
						size="small"
						icon="icon/indicazioni_blue.png"
					/>
				}
			/>
		</span>
	) : null;

	const routeSummaryHTML =
		routeDistance && routeTime ? (
			<span className={styles.routeSummary}>
				<span className={styles.routeDistance}>{routeDistance}</span>
				&nbsp;({routeTime})
			</span>
		) : null;

	const streetViewHTML = streetView ? (
		<span id={`streetView_${resultId}`}>
			<Label
				text="Street view"
				onClick={onStreetViewClick ? onStreetViewClick : null}
				icon={
					<Icon
						textOn="right"
						size="small"
						icon="icon/street_view_blue.png"
					/>
				}
			/>
		</span>
	) : null;

	const phoneHTML = phone ? (
		<Label
			text={phone}
			icon={
				<Icon
					icon="icon/telefono_blue.png"
					size="small"
					textOn="right"
				/>
			}
			variant="small"
		/>
	) : null;

	const faxHTML = fax ? (
		<Label
			text={fax}
			icon={<Icon icon="icon/fax_blue.png" size="small" textOn="right" />}
			variant="small"
		/>
	) : null;

	const emailHTML = email ? (
		<Label
			text={email}
			icon={
				<Icon icon="icon/mail_blue.png" size="small" textOn="right" />
			}
			link={`mailto:${email}`}
			variant="small"
			noUppercase={true}
		/>
	) : null;

	const siteHTML = site ? (
		<Label
			text="Visita il sito"
			icon={
				<Icon icon="icon/sito_blue.png" size="small" textOn="right" />
			}
			link={site}
			variant="small"
			noUppercase={true}
		/>
	) : null;

	const facebookHTML = facebook ? (
		<Label
			text="Visita la pagina facebook"
			icon={
				<Icon
					icon="icon/facebook_blue.png"
					size="small"
					textOn="right"
				/>
			}
			link={facebook}
			variant="small"
			noUppercase={true}
		/>
	) : null;

	// const greenCertification = hasCertificazioneGreen ? (
	// 	<div>
	// 		<Icon icon={'services/foglia.png'} size="large" />
	// 	</div>
	// ) : null;

	return (
		<div
			className={clsx(
				styles.root,
				focus && styles.focus,
				flex && styles.flex,
				variant && styles[variant]
			)}
		>
			{nameHTML}
			{icons}
			{addressHTML}
			{calcRouteHTML}
			{streetViewHTML}
			{linkTextHTML}
			{routeSummaryHTML}
			{phoneHTML}
			{faxHTML}
			{emailHTML}
			{siteHTML}
			{facebookHTML}
		</div>
	);
}
